// load inline polyfill if the Intl API isn't available,
// namely in Node
const intl = global.Intl || {NumberFormat: () => ({})};

export default function numberFormat(value, options = {}) {
    if (typeof options !== 'object') {
        throw new Error('numberFormat: Decimal argument should be an object');
    }
    if (isNaN(value)) {
        return value;
    }
    return new intl.NumberFormat('en-US', options).format(value);
}
